import { useMutation } from '@tanstack/react-query';
import type { ApiError } from '@/shared/api/ApiError';
import { getAuthRepository } from '../infrastructure/repositories/container';
import { loginUseCase } from './LoginUseCase';
import { clearAuthSession } from '../domain/entities/AuthSession';
import type { AuthSession } from '../domain/entities/AuthSession';

interface LoginInput {
  email: string;
  password: string;
}

export const useLoginMutation = () =>
  useMutation<AuthSession, ApiError, LoginInput>({
    mutationFn: ({ email, password }) =>
      loginUseCase(getAuthRepository(), email, password),
  });

export const useForgotPasswordMutation = () =>
  useMutation<void, ApiError, { email: string }>({
    mutationFn: ({ email }) => getAuthRepository().forgotPassword(email),
  });

export const useLogoutMutation = () =>
  useMutation<void, ApiError, void>({
    mutationFn: async () => { clearAuthSession(); },
  });
